import ArticleCard from '@/components/feature/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">编辑推荐的深度解析内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featured.map((article, index) => (
            <div key={article.id} className={index === 0 ? 'md:col-span-3' : ''}>
              <ArticleCard
                article={article}
                variant={index === 0 ? 'featured' : 'default'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}